/**
 * Rutas de la aplicación (una sola fuente para links, redirects y navegación).
 *
 * Se mantienen en inglés y en plural, alineadas con los recursos del backend
 * (`/api/tenants/:tenantId/products`, `/orders`, `/crm`…) para que la URL del navegador
 * se lea igual que el contrato de la API.
 */
export const ROUTES = {
  /** Raíz: redirige según haya sesión o no. */
  root: '/',

  // Públicas
  login: '/login',
  register: '/register',
  /** Vitrina pública del negocio (sin login): `/c/:slug`. */
  catalogo: '/c/:slug',

  // Panel (requieren sesión)
  dashboard: '/dashboard',
  conversations: '/conversations',
  orders: '/orders',
  products: '/products',
  crm: '/crm',
  campaigns: '/campaigns',
  templates: '/templates',
  reports: '/reports',
  integrations: '/integrations',
  /**
   * Ajustes en pestañas. `settings` es la raíz y redirige a `settingsGeneral`; las tres
   * cuelgan de ella para que el título del header siga siendo "Ajustes" (el shell resuelve la
   * sección por prefijo de ruta, ver `findNavItem`).
   */
  settings: '/settings',
  settingsGeneral: '/settings/general',
  settingsPayments: '/settings/payments',
  settingsTeam: '/settings/team',
  help: '/help',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

/**
 * Parámetro con la conversación abierta del inbox (`/conversations?conversacion=<id>`).
 *
 * Vive aquí y no dentro de `InboxPage` porque hay dos sitios que tienen que construir el enlace: la
 * propia pantalla (guarda la selección en la URL para poder recargar sin perderla) y los avisos de
 * mensajes nuevos (`features/alerts`), que llevan al chat que acaba de escribir.
 */
export const INBOX_CONVERSATION_PARAM = 'conversacion';

/** Enlace al inbox con una conversación abierta (lo que hace el aviso de mensajes nuevos). */
export function conversationLink(conversationId: string): string {
  return `${ROUTES.conversations}?${INBOX_CONVERSATION_PARAM}=${encodeURIComponent(conversationId)}`;
}
